  
export var completeQuestions = [
  {
    "control": "version",
    "key": "V01.00.000",
    "title": "Initial Version",
    "text": "",
    "type": "",
    "choices": "",
    "condition": "",
    "mandatory": ""
  },
  {
    "control": "choice",
    "key": "agreeGradient-5",
    "title": "",
    "text": "",
    "type": "",
    "choices": "strongly disagree: 0, disagree: 1, neither: 2, agree: 4, strongly agree: 5",
    "condition": "",
    "mandatory": ""
  },
  {
    "control": "section",
    "key": "Communication",
    "title": "Communication",
    "text": "",
    "type": "",
    "choices": "",
    "condition": "",
    "mandatory": ""
  },
  {
    "control": "question",
    "key": "smoothComm",
    "title": "",
    "text": "The company has smooth flowing internal and external communication.",
    "type": "choice",
    "choices": "agreeGradient-5",
    "condition": "",
    "mandatory": ""
  }
]

export var version = "V01.00.000"

export var completeList = [
  {
    version: "current",
    description: "Initial Added Some Stuff"
  },
  {
    version: "V01.00.000",
    description: "Initial Questions"
  },
  {
    version: "V01.00.000",
    description: "Initial Added Some Stuff"
  }
]

export default completeQuestions